import React from 'react';
import dayjs from 'dayjs';

// components
import { UnorderedListWithCheckbox } from 'baseComponents/UnorderedListWithCheckbox';
import { TextComponent } from 'baseComponents/TextComponent';
import { PreviewBoxComponent } from 'baseComponents/PreviewBoxComponent';

// screens
import { TabContentWrapper } from 'screens/CreateCampaignScreen/components/TabContentWrapper';

// constants
import { CREATE_CAMPAIGN_SCREEN } from 'constants/enums/create-campaign-screen';

// styles
import './previewCampaign.scss';

// store
import { useCreateCampaignStore } from 'store/CreateCampaignStore';
import { IosPushPreview } from 'components/IosPushPreview/IosPushPreview';
import { AndroidPushPreview } from 'components/AndroidPushPreview/AndroidPushPreview';

interface Props {
  estimatedCampaignCost: string;
  selectedChannel: 'sms' | 'push';
}

export const PreviewCampaign: React.FC<Props> = (props) => {
  // zustand store
  const campaignName = useCreateCampaignStore((state) => state.name);
  const campaignDate = useCreateCampaignStore((state) => state.sendDate);
  const campaignTime = useCreateCampaignStore((state) => state.sendTime);
  const campaignMessageMessage = useCreateCampaignStore(
    (state) => state.message
  );
  const campaignMessageTitle = useCreateCampaignStore((state) => state.title);
  const campaignMessagePreview = useCreateCampaignStore(
    (state) => state.previewMessage
  );
  const campaignAudience = useCreateCampaignStore((state) => state.audience);

  const nextSendTime = () => {
    if (campaignDate && campaignTime) {
      return `${dayjs(campaignDate).format('D MMMM YYYY')} ${dayjs(
        campaignTime
      ).format('HH:mm')}`;
    }
    return '';
  };

  const audienceName = campaignAudience?.name;

  return (
    <TabContentWrapper tabTitle={CREATE_CAMPAIGN_SCREEN.PREVIEW_CAMPAIGN}>
      <div className='preview-wrapper'>
        <PreviewBoxComponent label={CREATE_CAMPAIGN_SCREEN.CAMPAIGN_NAME}>
          <div className='preview-box-content-wrapper'>
            <TextComponent size='middle-large' text={campaignName} />
          </div>
        </PreviewBoxComponent>
        <PreviewBoxComponent label={'Channel'}>
          <div className='preview-box-content-wrapper'>
            <TextComponent
              size='middle-large'
              text={
                props.selectedChannel.charAt(0).toUpperCase() +
                props.selectedChannel.slice(1)
              }
            />
          </div>
        </PreviewBoxComponent>
        <PreviewBoxComponent label={CREATE_CAMPAIGN_SCREEN.NEXT_SEND_TIME}>
          <div className='preview-box-content-wrapper'>
            <TextComponent size='middle-large' text={nextSendTime()} />
          </div>
        </PreviewBoxComponent>
        <PreviewBoxComponent
          label={CREATE_CAMPAIGN_SCREEN.CREDIT_COST}
          tooltipText={CREATE_CAMPAIGN_SCREEN.CREDIT_COST_INFO}
        >
          <div className='preview-box-content-wrapper'>
            <TextComponent
              size='middle-large'
              text={props.estimatedCampaignCost || '0'}
            />
          </div>
        </PreviewBoxComponent>
        <PreviewBoxComponent label={CREATE_CAMPAIGN_SCREEN.SELECTED_AUDIENCE}>
          <div className='preview-box-content-wrapper'>
            {audienceName && (
              <UnorderedListWithCheckbox listItems={[audienceName]} />
            )}
          </div>
        </PreviewBoxComponent>
        {props.selectedChannel === 'sms' && (
          <PreviewBoxComponent
            label={CREATE_CAMPAIGN_SCREEN.PREVIEW_MESSAGE}
            previewMessage={campaignMessagePreview}
            hardcodedHeight
          >
            <div className='preview-box-content-wrapper'></div>
          </PreviewBoxComponent>
        )}
        {props.selectedChannel === 'push' && (
          <PreviewBoxComponent label={CREATE_CAMPAIGN_SCREEN.PREVIEW_MESSAGE}>
            <div className='preview-box-content-wrapper'>
              {props.selectedChannel === 'push' && (
                <div className='preview-box__push'>
                  <IosPushPreview
                    title={campaignMessageTitle}
                    body={campaignMessageMessage}
                    time='now'
                  />
                  <AndroidPushPreview
                    title={campaignMessageTitle}
                    body={campaignMessageMessage}
                    time='now'
                  />
                </div>
              )}
            </div>
          </PreviewBoxComponent>
        )}
      </div>
    </TabContentWrapper>
  );
};
